import qs from "qs";
import React, {
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import { setTimeAndUser } from "../../../lib/calculation";
import { get } from "../../../lib/comm";
import {
  deleteComment,
  saveTextCommentAndPhoto,
  save as inspection_save,
} from "../../../lib/inspection_saver";
import InspectionService from "../../../lib/inspection_service";
import {
  lock,
  MESSAGE_TYPE_OOS,
  MESSAGE_TYPE_REJECT,
  subEquipmentStepCanProceed,
  validate,
} from "../../../lib/inspection_validator";
import { MainContext, UpdateContext } from "../../../main-context";
import Check from "../../helpers/Check/Check";
import { useQuery } from "../../helpers/Hooks";
import Spinner from "../../helpers/Spinner";
import wizard_css from "../../inspection.module.css";

export default function WizardDetail({
  inspection,
  update_db,
  set_offline_count,
}) {
  // const ERROR_OUT_OF_SERVICE = 3;
  const ERROR_TIMES_UP = 2;
  const search = useQuery();
  const history = useHistory();
  const main_context = useContext(MainContext);
  const update_context = useContext(UpdateContext);
  const params = useParams();
  const location = useLocation();
  const service = useRef(new InspectionService());

  const [
    display_inspection_complete_button,
    set_display_inspection_complete_button,
  ] = useState(false);
  const [display_next_button, set_display_next_button] = useState(false);
  const [progressMessage, set_progressMessage] = useState("Loading...");
  const [backButton, set_backButton] = useState(false);
  const [data, set_local_data] = useState();

  const set_data = useCallback(
    (event) => {
      set_local_data(event);
      if (event && {}.toString.call(event) === "[object Function]") {
        update_db(event());
      } else if (event) {
        update_db(event);
      }
    },
    [update_db]
  );

  const [settings, set_settings] = useState({
    activeStep: 0,
  });

  function getOOSMessage(messages) {
    let result = null;
    for (var i = messages.length - 1; i >= 0; i--) {
      if (+messages[i].type === MESSAGE_TYPE_OOS) {
        return messages[i].title;
      }
    }
    return result;
  }

  /* TODO Make one get message function */
  function getRejectMessage(messages) {
    let result = null;
    for (var i = messages.length - 1; i >= 0; i--) {
      if (+messages[i].type === MESSAGE_TYPE_REJECT) {
        return messages[i].title;
      }
    }
    return result;
  }

  // TODO CHECK on location change EVENT

  const isStepDone = useCallback((check) => {
    return check.success === true && subEquipmentStepCanProceed(check) === true;
  }, []);

  const isValid = useMemo(() => {
    if (data) {
      let messages = validate(data, params.type);
      return !messages.length;
    }
    return true;
  }, [data, params.type]);

  const isLast = useMemo(() => {
    let allDone = true;
    if (data) {
      data.checks.forEach(function (check) {
        if (
          isStepDone(check) === false &&
          !data.disabledChecks.includes(check.check_id)
        ) {
          allDone = false;
          return false;
        }
      });
    }
    return allDone;
  }, [data, isStepDone]);

  const pop = useCallback(
    (backlink_obj, redirect) => {
      service.current.pop();
      const ss = qs.stringify({ step: backlink_obj.step });
      if (redirect) {
        const url = backlink_obj.path + "?" + ss;
        history.push(url);
      } else {
        history.push(location.pathname + "?" + ss);
      }
    },
    [history, location.pathname]
  );

  const save = useCallback(
    (
      data_copy,
      user_id,
      update_context,
      history,
      inspection_complete,
      nextEquipment
    ) => {
      const messages = validate(data_copy, params.type);
      let oos = false;

      if (
        messages.length &&
        getOOSMessage(messages) &&
        !search.get("partial")
      ) {
        const continueSaving = window.confirm(
          getOOSMessage(messages) +
            " will put this equipment out of service. Are you sure?"
        );
        if (!continueSaving) {
          return false;
        }

        set_progressMessage("Equipment is Out of Service...");
        oos = true;
      }

      if (messages.length && getRejectMessage(messages)) {
        const continueSaving = window.confirm(
          getRejectMessage(messages) +
            ". This will stop the receipt. Are you sure?"
        );
        if (!continueSaving) {
          return false;
        }

        set_progressMessage("Receipt is rejected...");
        oos = true;
      }

      const step = settings.activeStep;
      data_copy.checks[step].saving = true;

      const onlyOneCheckData = {
        date: data_copy.date,
        equipment: data_copy.equipment,
        checks: [data_copy.checks[step]],
        inspection_complete: inspection_complete,
        operationId: data_copy.operationId,
      };

      if (oos) {
        data_copy.all_deleted = true;
      }

      return inspection_save(
        params.type,
        user_id,
        update_context,
        history,
        onlyOneCheckData,
        search.get("inspection_maintainer"),
        search.get("inspectionId")
      ).then(function (res) {
        // set time if photo
        setTimeAndUser(
          data_copy.checks[step],
          main_context.status.get_full_name
        );

        let backRoute = update_context.settings.subfolder;

        if (+res.status === ERROR_TIMES_UP) {
          window.alert("Sorry, inspection is outdated!");
          history.goBack();
          return true;
        }

        if (inspection_complete || oos) {
          set_offline_count(true, null, oos); // offline number not used when all is done
          update_context.update_main_context((prev) => ({
            ...prev,
            done_intercompany: {
              ...prev.done_intercompany,
              [data_copy.equipment.id +
              "-" +
              data_copy.operationId +
              "-" +
              params.type]: true,
            },
          })); // here we mark inspection as offline_complited for interconnected to recognize that
          if (service.current.peek() != null) {
            return pop(service.current.peek(), true);
          } else {
            var nexteqapi;
            if (params.type === "daily") {
              nexteqapi = "daily";
              backRoute += "/inspections/daily";
            } else if (params.type === "fso") {
              nexteqapi = "fso";
              backRoute += "/inspections/fso";
            } else if (params.type === "weekly") {
              nexteqapi = "weekly";
              backRoute += "/inspections/weekly";
            } else if (params.type === "truck-receipt") {
              nexteqapi = "truck-receipt";
              backRoute += "/inventory/fuel-receipt";
            } else if (params.type === "pipeline-receipt") {
              nexteqapi = "pipeline-receipt";
              backRoute += "/inventory/fuel-receipt";
            } else if (params.type === "fuel-ticket") {
              nexteqapi = "fuel-ticket";
              backRoute += "tickets";
            } else if (params.type === "top-off-ticket") {
              nexteqapi = "top-off-ticket";
              backRoute += "tickets";
            } else if (params.type === "defuel-ticket") {
              nexteqapi = "defuel-ticket";
              backRoute += "tickets";
            } else if (params.type === "recirc-ticket") {
              nexteqapi = "recirc-ticket";
              backRoute += "tickets";
            } else {
              nexteqapi = "maintenance";
              backRoute += "/inspections/maintenance";
            }
            if (nextEquipment) {
              get(
                "/api/inspections/" + nexteqapi,
                null,
                main_context.status.id,
                update_context,
                history
              ).then((res) => {
                if (res === "comm error") return;
                var lastEq = 0;
                var nextEqId = 0;
                var nextOpId = 0;
                for (var ii = 0; ii < res[params.type].length; ii++) {
                  if (res[params.type][ii].id === data_copy.equipment.id) {
                    lastEq = data_copy.equipment.id;
                  } else if (lastEq > 0 && !res[params.type][ii].closed) {
                    nextEqId = res[params.type][ii].id;
                    nextOpId = res[params.type][ii].operationId;
                    break;
                  }
                }
                if (nextEqId > 0) {
                  set_progressMessage("Loading...");
                  history.push(
                    update_context.settings.subfolder +
                      "/wizard/" +
                      params.type +
                      "/" +
                      nextEqId +
                      "/" +
                      (nexteqapi === "fso" ? "1" : nextOpId)
                  );
                  return;
                }
                history.push(backRoute);
                return;
              });
            } else {
              history.push(backRoute);
              return;
            }
          }
        } else {
          lock(data_copy, step);
          data_copy.checks[step].offline_complete =
            data_copy.checks[step].success;
          data_copy.checks[step].saving = false;
          set_data({ ...data_copy });
          set_offline_count(
            false,
            data_copy.checks.filter((x) => x.offline_complete).length,
            false
          );
        }
      });
    },
    [
      main_context.status.get_full_name,
      main_context.status.id,
      params.type,
      pop,
      search,
      set_data,
      set_offline_count,
      settings.activeStep,
    ]
  );

  const gotoStep = useCallback(
    (stepNumber) => {
      if (stepNumber === settings.activeStep) return;

      let data_copy = { ...data };
      if (data_copy.checks[settings.activeStep].value) {
        let success = save(
          data_copy,
          main_context.status.id,
          update_context,
          history
        );
        if (!success) return;
      }

      if (data_copy.all_deleted) {
        data_copy = null;
      } else {
        set_settings((prev) => ({
          ...prev,
          activeStep: stepNumber,
        }));
      }

      set_data(data_copy);
    },
    [
      data,
      history,
      main_context.status.id,
      save,
      set_data,
      settings.activeStep,
      update_context,
    ]
  );

  const nextStep = useCallback(
    (inspection_complete, nextEquipment) => {
      window.scrollTo(0, 0);

      if (isLast && inspection_complete) {
        let data_copy = { ...data };
        if (
          save(
            data_copy,
            main_context.status.id,
            update_context,
            history,
            isLast,
            nextEquipment
          )
        ) {
          set_progressMessage("Saving...");
          set_data(null);
          return;
        }
      }

      if (settings.activeStep + 1 === data.checks.length) {
        let notCompletedIndex;
        data.checks.forEach(function (step, i) {
          if (!isStepDone(step) && notCompletedIndex === undefined) {
            notCompletedIndex = i;
            return false;
          }
        });

        return gotoStep(notCompletedIndex);
      }

      gotoStep(settings.activeStep + 1);
    },
    [
      data,
      gotoStep,
      history,
      isLast,
      isStepDone,
      main_context.status.id,
      save,
      set_data,
      settings.activeStep,
      update_context,
    ]
  );

  const backToParent = useCallback(() => {
    pop(service.current.peek(), true);
  }, [pop]);

  const saveTextCommentAndPhotoEvent = useCallback(
    (param_data) => {
      return saveTextCommentAndPhoto(
        params.type,
        data,
        search.get("inspection_maintainer"),
        param_data.comment,
        param_data.photo,
        param_data.id,
        search.get("inspectionId"),
        main_context.status.id,
        update_context,
        history,
        param_data.ident
      ).then(function (responseData) {
        return responseData;
      });
    },
    [data, history, main_context.status.id, params.type, search, update_context]
  );

  // TODO CHECK
  const deleteCommentEvent = useCallback(
    (param_data) => {
      return deleteComment(
        param_data.id,
        main_context.status.id,
        update_context,
        history
      ).then(function (responseData) {
        return responseData;
      });
    },
    [history, main_context.status.id, update_context]
  );

  useEffect(() => {
    set_display_inspection_complete_button(false);
    set_display_next_button(false);
    if ((isLast || (!isValid && !search.get("partial"))) === true) {
      set_display_inspection_complete_button(true);
    } else if (!isLast) {
      set_display_next_button(true);
    }
  }, [isLast, isValid, search]);

  useEffect(() => {
    if (search.get("step")) {
      // debugger;
      set_settings((prev) => ({
        ...prev,
        activeStep: parseInt(search.get("step")),
      }));
    }
  }, [search]);

  useEffect(() => {
    if (
      data &&
      data.checks.length &&
      data.checks[settings.activeStep].name === "ENGINE_HOURS_DISABLE"
    ) {
      for (
        let opi = 0;
        opi < data.checks[settings.activeStep].options.length;
        opi++
      ) {
        data.checks[settings.activeStep].options[opi].disabled =
          data.checks[settings.activeStep].options[opi].valueName >
          data.equipment.engineHoursAlt;
      }
    }
  }, [data, settings.activeStep]);

  useEffect(() => {
    const prevlink = service.current.peek();

    if (prevlink && location.pathname.indexOf(prevlink.path) > -1) {
      pop(prevlink, false);
    }

    set_backButton(service.current.peek());
  }, [location, pop]);

  useEffect(() => {
    set_data(
      inspection
        ? {
            ...inspection,
            checks: inspection.checks.map((x) => ({
              ...x,
              offline_complete: x.handled,
            })),
          }
        : inspection
    );
  }, [inspection, params.type, set_data]);

  useEffect(() => {
    if (
      location.pathname.startsWith(
        update_context.settings.subfolder + "/wizard/"
      )
    ) {
      update_context.update_main_context((prev) => ({
        ...prev,
        data: null,
      }));
      set_progressMessage("Loading...");
    }
  }, [location.pathname, update_context]);

  // TODO CHECK
  const toSubEquipmentInspection = useCallback(
    (equipment_id) => {
      if (data) {
        service.current.push({
          path: location.pathname,
          name: data.equipment.name,
          step: settings.activeStep,
        });
        const qsv = qs.stringify({ step: 0 });
        history.push(
          update_context.settings.subfolder +
            service.current.generateInspectionUrl(
              equipment_id,
              params.type,
              data.operationId
            ) +
            "?" +
            qsv
        );
      }
    },
    [
      data,
      history,
      location.pathname,
      params.type,
      settings.activeStep,
      update_context.settings.subfolder,
    ]
  );

  // TODO CHECK
  function showErrors() {}

  return (
    <MainContext.Consumer>
      {() => (
        <div className={wizard_css["inspection-wizard"]}>
          {!!backButton && !!data && (
            <span className={wizard_css["span-special"]} onClick={backToParent}>
              &lt; Back to {backButton.name}
            </span>
          )}
          <h1 className="text-center">{data?.equipment.name}</h1>
          {!data && (
            <div className="text-center">
              <h2>
                <span>{progressMessage}</span>
                <Spinner
                  waitfor={data}
                  style={{ marginLeft: "20px", position: "relative" }}
                ></Spinner>
              </h2>
            </div>
          )}
          {!!data && (
            <>
              <h4>Steps:</h4>
              <div className="clearfix">
                {data.checks.map((elem, index) => (
                  <div
                    key={elem.id}
                    className={`${wizard_css["step-wrap"]} ${
                      settings.activeStep === index ? wizard_css["active"] : ""
                    }`}
                  >
                    {/* <!-- prevent jumping of button by placing saving... on top of button --> */}
                    {!!elem.saving && (
                      <div className={wizard_css["saving"]}>
                        <i className="fa fa-cog fa-spin"></i>
                      </div>
                    )}

                    <span
                      className={`btn btn-default ${wizard_css["step"]} ${
                        settings.activeStep === index
                          ? wizard_css["active"]
                          : ""
                      } ${
                        (elem.locked &&
                          !data.disabledChecks.includes(elem.check_id)) ||
                        elem.childrenLocked
                          ? "btn-danger"
                          : ""
                      } ${elem.success ? "btn-success" : ""} ${
                        data.disabledChecks.includes(elem.check_id)
                          ? "background-bbb"
                          : ""
                      }`}
                      onClick={() => gotoStep(index)}
                    >
                      {elem.title}
                    </span>
                  </div>
                ))}
              </div>
              {data.checks.map((elem, index) => (
                <div
                  className={wizard_css["inspection-lower-wrapper"]}
                  key={elem.id}
                >
                  {/* <!-- pass in some inspection functions since they are ng-clicked on buttons within the check template, but really belong at inspection level --> */}
                  {index === settings.activeStep && (
                    <Check
                      check={elem}
                      equipment={data.equipment}
                      topLevel={true}
                      station={data.station}
                      tosubequipmentinspection={toSubEquipmentInspection}
                      saveTextCommentAndPhoto={saveTextCommentAndPhotoEvent}
                      deleteComment={deleteCommentEvent}
                      data={data}
                      index={index}
                      set_data={set_data}
                      type={params.type}
                      params={params}
                    ></Check>
                  )}
                </div>
              ))}

              {/* <!-- isvalid: {{isvalid}}<br />
                islast: {{islast}}<br />
                display_inspection_complete_button: {{display_inspection_complete_button}}<br />
                display_next_button: {{display_next_button}} --> */}
              {!!display_next_button && (
                <button
                  onClick={nextStep}
                  className={`btn btn-lg ${wizard_css["btn-next"]} btn-block btn-success`}
                >
                  Next
                </button>
              )}

              <div
                className={`${
                  params.type !== "truck-receipt" &&
                  params.type !== "pipeline-receipt"
                    ? "col-sm-8"
                    : ""
                }`}
                style={{ paddingRight: "5px" }}
              >
                {!!display_inspection_complete_button && (
                  <button
                    className={`btn btn-lg ${
                      wizard_css["btn-next"]
                    } btn-block ${isValid && !isLast ? "btn-success" : ""} ${
                      !isValid ? "btn-danger" : ""
                    } ${isLast ? "btn-primary" : ""}`}
                    onClick={() => {
                      nextStep(true) || showErrors(isValid);
                    }}
                  >
                    Inspection Complete
                  </button>
                )}
              </div>
              <div className="col-sm-4" style={{ paddingLeft: "0" }}>
                {!!display_inspection_complete_button &&
                  params.type !== "truck-receipt" &&
                  params.type !== "pipeline-receipt" && (
                    <button
                      className={`btn btn-lg ${
                        wizard_css["btn-next"]
                      } btn-block ${isValid && !isLast ? "btn-success" : ""} ${
                        !isValid ? "btn-danger" : ""
                      } ${isLast ? "btn-primary" : ""}`}
                      onClick={() => {
                        nextStep(true, true) || showErrors(isValid);
                      }}
                    >
                      Start Next
                    </button>
                  )}
              </div>
            </>
          )}
        </div>
      )}
    </MainContext.Consumer>
  );
}
